<h2 class="secondary word-break">
    {{ 'tokens.browser.name.title' | apContent }}
</h2>
<p>{{ 'tokens.browser.name.info' | apContent }}</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <ap-grid-row>
        <ap-grid-col [sm]="6">
            <div class="ap-margin-bottom-4 ap-display-block">
                <ap-input
                    data-bb="name-input"
                    type="text"
                    apInputRef
                    [label]="'tokens.browser.name.label' | apContent"
                    (inputBlur)="onBlur()"
                    [formControl]="form.get('name') | apFormControl"
                    [attr.aria-label]="getAriaLabel()"
                    [messages]="errorMessage"
                >
                </ap-input>
                <p data-bb="help-text" class="ap-help-text">
                    <ap-content key="tokens.browser.name.helpText"></ap-content>
                </p>
            </div>
        </ap-grid-col>
    </ap-grid-row>

    <div class="ap-margin-bottom-4 ap-display-block">
        <div class="ap-flex ap-flex-row ap-flex-sm-column-reverse ap-flex-1">
            <ap-button (onClick)="goBack()" data-bb="back" variant="secondary" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.name.back' | apContent }}
            </ap-button>
            <ap-button type="submit" data-bb="submit" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.name.submit' | apContent }}
            </ap-button>
        </div>
    </div>
</form>
